import api from './api';

const authService = {
  // Login user
  login: async (credentials) => {
    return api.post('/auth/login', credentials);
  },
  
  // Register user
  register: async (userData) => {
    return api.post('/auth/register', userData);
  },
  
  // Get current user
  getMe: async () => {
    return api.get('/auth/me');
  },
  
  // Update user profile
  updateProfile: async (userData) => {
    return api.put('/auth/me', userData);
  },
  
  // Change password
  changePassword: async (passwordData) => {
    return api.put('/auth/password', passwordData);
  }
};

export default authService;